/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import {
    func, object, bool, string,
} from 'prop-types';
import isPastCutoff from '../../../../helpers/determineCutoffTime';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    todayTomorrowWrapper: {
        display: 'flex',
    },
    buttonToday: {
        marginRight: '10px',
        width: '55%',
        // height: '52px',
        color: 'white',
        fontSize: '16px',
        textAlign: 'center',
        lineHeight: '52px',
        height: '52px',
        background: '#61C278',
        border: 'none',
        outline: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '600',
        '&:active': {
            background: '#45b071',
        },
        '&:focus': {
            // TODO: Handle outline for accesibility
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    buttonTomorrow: {
        marginRight: '10px',
        width: '55%',
        color: 'white',
        fontSize: '16px',
        textAlign: 'center',
        lineHeight: '52px',
        height: '52px',
        background: '#61C278',
        border: 'none',
        borderRadius: '4px',
        outline: 'none',
        cursor: 'pointer',
        fontWeight: '600',
        '&:active': {
            background: '#45b071',
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    buttonCalendar: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        color: 'white',
        fontSize: '17px',
        textAlign: 'center',
        height: '52px',
        background: '#61C278',
        border: 'none',
        outline: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '600',
        marginBottom: '20px',
        [theme.breakpoints.down('600')]: {
            fontSize: '14px',
        },
        '&> svg': {
            width: '19px',
            paddingRight: '3px',
        },
        '&:active': {
            background: '#45b071',
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    marginRight: {
        marginRight: 6,
    },
});

const DeliveryCalendarButtonContainer = ({
    classes,
    addTodayOrTomToCart,
    fullCalendarCall,
    zipValid,
    productDeliveryType,
    isInternationalProduct,
    todayTomorrowFlagEnabled,
    displayDeliveryCalendar,
    dataDictionary,
}) => {
    const renderTodayTomorrow = todayTomorrowFlagEnabled && !isInternationalProduct && !isPastCutoff() && productDeliveryType === 'FPT' && displayDeliveryCalendar;
    const language = getLanguageName();
    return (
        <div className={classes.todayTomorrowWrapper}>
            {renderTodayTomorrow ? (
                <>
                    <button
                        type="button"
                        data-test="pdp-today-button"
                        id="today-button"
                        name="todayButton"
                        className={classes.buttonToday}
                        disabled={(zipValid === false)}
                        onClick={() => { addTodayOrTomToCart('today'); }}
                    >
                        {language === '/en' ? 'Today' : dataDictionary.Today}
                    </button>
                    <button
                        type="button"
                        data-test="pdp-tomorrow-button"
                        id="tomorrow-button"
                        name="tomorrowButton"
                        className={classes.buttonTomorrow}
                        disabled={(zipValid === false)}
                        onClick={() => { addTodayOrTomToCart('tomorrow'); }}
                    >
                        {language === '/en' ? 'Tomorrow' : dataDictionary.Tomorrow}
                    </button>
                </>
            ) : null }
            {
                /* eslint-disable no-nested-ternary */
                // The logic of the nested ternary below:
                // First part of ternary:
                // if the product is internation then display the calendar button with the text Pick A Delivery Date
                // Second part of ternary:
                // if the product is not international and we are currently displaying the today / tomorrow buttons
                // calendar button text is Full Calendar
                // if the product is not international if we are not displaying today / tomorrow buttons
                // calendar button text is Add to Cart
                isInternationalProduct ? (
                    <button
                        type="button"
                        id="btn-full-calendar"
                        data-test="pdp-btn-full-calendar"
                        data-testid="pdp-btn-full-calendar"
                        name="fullCalendarButton"
                        className={classes.buttonCalendar}
                        onClick={() => { fullCalendarCall(); }}
                    >
                        Pick A Delivery Date
                    </button>
                    /* eslint-disable no-nested-ternary */
                ) : renderTodayTomorrow ? (
                    <button
                        type="button"
                        id="btn-full-calendar"
                        data-test="pdp-btn-full-calendar"
                        name="fullCalendarButton"
                        className={classes.buttonCalendar}
                        disabled={(zipValid === false)}
                        onClick={() => { fullCalendarCall(); }}
                    >
                        <CalendarIcon className={classes.marginRight} /> {language === '/en' ? 'Full Calendar' : (dataDictionary['Full Calendar'] || 'Full Calendar')}
                    </button>
                ) : (
                    <button
                        type="button"
                        id="btn-full-calendar"
                        data-test="pdp-btn-full-calendar"
                        data-testid="pdp-btn-full-calendar"
                        name="fullCalendarButton"
                        className={classes.buttonCalendar}
                        disabled={(zipValid === false)}
                        onClick={() => { fullCalendarCall(); }}
                    >
                        <CalendarIcon className={classes.marginRight} /> {language === '/en' ? 'Choose A Delivery Date & Checkout' : dataDictionary['Choose A Delivery Date & Checkout']}
                    </button>
                )
            }
        </div>

    );
};

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
});

DeliveryCalendarButtonContainer.propTypes = {
    classes: object.isRequired,
    addTodayOrTomToCart: func.isRequired,
    fullCalendarCall: func.isRequired,
    zipValid: bool,
    productDeliveryType: string.isRequired,
    isInternationalProduct: bool.isRequired,
    todayTomorrowFlagEnabled: bool.isRequired,
    displayDeliveryCalendar: bool.isRequired,
    dataDictionary: object.isRequired,
};

DeliveryCalendarButtonContainer.defaultProps = {
    zipValid: null,
};

export default connect(mapStateToProps)(withStyles(styles)(DeliveryCalendarButtonContainer));
